<template>
    <div>
        <div class="img-container" style="{ height: imageHeight + 'px'; width: imageWidth + 'px' }">
            <img ref="image" :src="src" crossorigin>
        </div>
        <img :src="destination" class="img-preview">
    </div>
</template>

<script>
    import Cropper from "cropperjs";
    export default {
        name: "ImageCropper",
        data() {
            return {
                cropper: {},
                destination: {},
                image: {},
                imageHeight: 300,
                imageWidth: 300
            }
        },
         methods: {
            createCropper
        },
        props: {
            src: String
        },
        mounted() {
           
            this.image = this.$refs.image;
            var img = new Image(); 
            img.src = this.$refs.image.src;

            let that = this;
            var width_container = 300;
            var height_container = 300;
            this.imageHeight = 300;
            this.imageWidth = 300;
            
            img.onload = function(){

                //se for maior que a div que está
                if(img.width < width_container){
                    width_container = img.width;
                    height_container = img.height;
                }
                else{
                    height_container = (width_container*img.height)/img.width;

                }

                that.imageHeight = height_container;
                that.imageWidth = width_container;

                that.cropper = new Cropper(that.image, {
                        zoomable: false,
                        scalable: false,
                        aspectRatio: NaN,
                        viewMode: 1,
                        responsive: true,
                        minContainerHeight: height_container,
                        minContainerWidth: width_container,
                        minCanvasHeight: height_container,
                        minCanvasWidth: width_container,
                        autoCropArea: 1,
                        crop: function(e) {
                                const canvas = that.cropper.getCroppedCanvas();
                                that.destination = canvas.toDataURL("image/png");
                                that.$emit("updateCropedUrl", that.destination);
                        }
                });

            }
        },
        methods: {
            cropMethod
        }
    };

    function calculateCoeff(img_value, property){
        var x = 0;
        return 1;
    }

    function cropMethod(image, width, height){
            }

    function createCropper (image, width, height){
        this.imageHeight = height;
        this.imageWidth = width;

        var cropper = new Cropper(image, {
            zoomable: false,
            scalable: false,
            aspectRatio: NaN,
            viewMode: 1,
            responsive: true,
            minContainerHeight: height,
            minContainerWidth: width,
            minCanvasHeight: height,
            minCanvasWidth: width,
            autoCropArea: 1,
            crop: function(e) {
            }
        });
    }
</script>

<style scoped>
    .img-container img{
        max-width: 100%;
    }
    .img-preview {
        display: none;
        width: auto;
        height: auto;
        float: left;
        margin-left: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/ImageCropper.vue